import React from 'react';
import {SelectAsyncBase} from 'components/Forms/FormBases';
import {getPublicCertificationBodies} from 'api/certification-bodies';

SelectPublicCB.defaultProps = {
  placeholder: 'Select a Standard',
  isClearable: true,
  cacheOptions: true,
  defaultOptions: true,
  onChange: () => {},
  getOptionLabel: (option) => option.certification_bodies_name,
  getOptionValue: (option) => option.certification_bodies_id,
};

function SelectPublicCB(props) {
  const {value, ...rest} = props;

  async function getOptions(inputValue) {
    const query = {
      search: inputValue,
      limit: 20,
      status: 'active',
    };

    try {
      const {data} = await getPublicCertificationBodies(query);
      return data;
    } catch (error) {
      return [];
    }
  }

  return <SelectAsyncBase loadOptions={getOptions} {...rest} />;
}

export default SelectPublicCB;
